<template>
  <model-form
    ref="modelForm"
    :model="tipPoolTip"
    modal-type="modal"
    read-only
  >
    <div class="row q-col-gutter-sm items-center q-mt-sm">
      <router-field
        :field-value="tipShareValue"
        class="col-6"
        label="Tip Share"
        :link="{
          name: 'admin:operations-category-name-id',
          params: {
            category: 'staff',
            name: 'tip-shares',
            id: tipPoolTip.tipShare?.id
          }
        }"
        :disable="$_.isNil(tipPoolTip.tipShare)"
      />
      <model-form-input
        field="amount"
        class="col-6"
        label="Amount"
        :prefix="currentCircuit.localeCurrencySymbol"
        readonly
      />
      <router-field
        :field-value="orderValue"
        class="col-6"
        label="Order"
        :link="{
          name: 'admin:operations-category-name-id',
          params: {
            category: 'customers',
            name: 'orders',
            id: tipPoolTip?.tipShare?.orderItem?.order?.id
          }
        }"
        :disable="$_.isNil(tipPoolTip?.tipShare?.orderItem?.order)"
      />
      <model-form-input
        field="paymentType"
        class="col-6"
        label="Payment Type"
        :decode="paymentType => $_.startCase(paymentType)"
        readonly
      />
      <model-form-input
        field="state"
        class="col-6"
        label="State"
        :decode="state => $_.startCase(state)"
        readonly
      />
      <formatted-date
        :value="tipPoolTip.distributedAt"
        class="col-6 q-mb-md"
        label="Distributed At"
        component="input"
      />
      <formatted-date
        :value="tipPoolTip.paidAt"
        class="col-6 q-mb-md"
        label="Paid At"
        component="input"
      />
      <formatted-date
        :value="tipPoolTip.voidedAt"
        class="col-6 q-mb-md"
        label="Voided At"
        component="input"
      />
    </div>
  </model-form>
</template>

<script>
import FormattedDate from 'src/modules/admin/components/FormattedDate'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import RouterField from 'src/modules/admin/components/RouterField'

export default {
  name: 'TipPoolTipForm',
  components: {
    ModelForm,
    FormattedDate,
    RouterField
  },
  configuration: ['currentCircuit'],
  models: {
    tipPoolTip: {
      tipShare: {
        fields: ['id'],
        orderItem: {
          fields: ['id'],
          order: {
            fields: ['id']
          }
        },
        tipShareRule: {
          fields: ['id', 'name']
        }
      },
      tipPool: {
        fields: ['id']
      },
      tipPoolType: {
        fields: ['id', 'name']
      }
    }
  },
  computed: {
    orderValue () {
      if (!_.isNil(this.tipPoolTip?.tipShare?.orderItem?.order)) {
        return `O${this.tipPoolTip?.tipShare?.orderItem?.order?.id}`
      } else {
        return 'No Order'
      }
    },
    tipShareValue () {
      if (!_.isNil(this.tipPoolTip?.tipShare?.tipShareRule)) {
        return this.tipPoolTip?.tipShare?.tipShareRule?.name
      } else {
        return 'Not Shared'
      }
    }
  }
}
</script>
